import { gql } from '@apollo/client';

// TRIL-615: replaces a hand-rolled REST DELETE against a separately-configured API Gateway URL.
// Returns Boolean! and throws on failure — there is no soft-failure shape, deliberately.
export const DELETE_POST_MEDIA = gql`
    mutation DeletePostMedia($key: String!) {
        deletePostMedia(key: $key)
    }
`;
